import React from 'react';
import DynamicFieldRenderer from '../../components/Form/DynamicFieldRenderer';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import { useCustomFieldValues } from './useData';

interface EntityCustomFieldsSectionProps {
  entityType: string;
  entityId: number | null | undefined;
  title?: string;
  className?: string;
  compact?: boolean;
  emptyMessage?: string;
}

const EntityCustomFieldsSection: React.FC<EntityCustomFieldsSectionProps> = ({
  entityType,
  entityId,
  title = 'Custom fields',
  className,
  compact = false,
  emptyMessage,
}) => {
  const { colors } = useTheme();
  const resolvedId = entityId != null && entityId > 0 ? entityId : null;
  const { data: fields, isLoading } = useCustomFieldValues(entityType, resolvedId);

  if (!resolvedId) return null;
  if (isLoading) {
    return (
      <div className={cn(compact ? 'py-2' : 'py-3', className)}>
        <p className={cn('text-sm', colors.textMuted)}>Loading custom fields…</p>
      </div>
    );
  }
  if (!fields?.length) {
    if (emptyMessage) {
      return (
        <div className={cn(compact ? 'py-2' : 'py-3', className)}>
          <p className={cn('text-sm', colors.textMuted)}>{emptyMessage}</p>
        </div>
      );
    }
    return null;
  }

  return (
    <div
      className={cn(
        compact ? 'pt-3' : 'border-t pt-4 mt-4',
        colors.border,
        className,
      )}
    >
      {title ? (
        <h3 className={cn(compact ? 'text-sm font-medium mb-2' : 'text-sm font-semibold mb-3', colors.text)}>
          {title}
        </h3>
      ) : null}
      <DynamicFieldRenderer entityType={entityType} entityId={resolvedId} />
    </div>
  );
};

export default EntityCustomFieldsSection;
